const SERVICE = 'customer'

const profile = async api => api.setMethod().get().setService(SERVICE).process('/profile')

const updateProfile = async (api, params, body) => api.setMethod().post()
  .setService(SERVICE).setBody(body)
  .process('/profile', params)

module.exports = {
  profile,
  updateProfile,
}
